import { match, P } from 'ts-pattern';
import { z } from 'zod';

import { textSchemaWithMarks } from 'schemas/story';

import { StoryParagraph } from 'types/Story';

export const mapParagraphNodeToText = (
  node: z.infer<typeof textSchemaWithMarks>
) => {
  if (node.marks) {
    return node.marks.reduce((acc, mark, index) => {
      const getKey = () => `${node.text}-${index}`;
      match(mark.type)
        .with('bold', () => (acc = <b key={getKey()}>{acc}</b>))
        .with('italic', () => (acc = <i key={getKey()}>{acc}</i>))
        .with('strike', () => (acc = <s key={getKey()}>{acc}</s>))
        .exhaustive();
      return acc;
    }, node.text as React.ReactNode);
  } else {
    return node.text;
  }
};

export const mapStoryParagraphJsonToText = (json: StoryParagraph) => {
  return match(json)
    .with(
      { content: P.array({ type: 'paragraph', content: P.select() }) },
      (content) => {
        return content.flatMap((node) => {
          return node.map(mapParagraphNodeToText);
        });
      }
    )
    .exhaustive();
};
